import { isNil } from 'lodash-es';
export class FastDomInternal {
    constructor() {
        this.scheduled = false;
        this.measureQueue = [];
        this.mutateQueue = [];
    }
    async measure(task) {
        return new Promise((resolve, reject) => {
            this.measureQueue.push(() => {
                try {
                    resolve(task());
                }
                catch (e) {
                    reject(e);
                }
            });
            this.schedule();
        });
    }
    async mutate(task) {
        return new Promise((resolve, reject) => {
            this.schedule();
            this.mutateQueue.push(() => {
                try {
                    task();
                    resolve();
                }
                catch (e) {
                    reject(e);
                }
            });
        });
    }
    schedule() {
        if (!this.scheduled) {
            this.scheduled = true;
            requestAnimationFrame(() => {
                this.scheduled = false;
                const mutateQueue = this.mutateQueue;
                this.mutateQueue = [];
                const measureQueue = this.measureQueue;
                this.measureQueue = [];
                for (const task of mutateQueue) {
                    task();
                }
                for (const task of measureQueue) {
                    task();
                }
            });
        }
    }
}
export function isNodeAChildOf(parent, potentialChild) {
    for (const child of parent.children) {
        if (child === potentialChild) {
            return true;
        }
    }
    return false;
}
export function removeAllChildrenSync(parent) {
    while (parent.children.length > 0) {
        const item = parent.children.item(0);
        if (!isNil(item)) {
            item.remove();
        }
    }
}
export function removeAllChildren(parent) {
    fastDom
        .mutate(() => {
        removeAllChildrenSync(parent);
    })
        .then()
        .catch(e => console.error(e));
}
export function removeAllChildrenAsync(parent) {
    return fastDom.mutate(() => {
        removeAllChildrenSync(parent);
    });
}
export function calcRightOffset(elem, container, scrollContainer) {
    return fastDom.measure(() => {
        var _a;
        const scrollLeft = (_a = scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollLeft) !== null && _a !== void 0 ? _a : 0;
        if (container.getBoundingClientRect().right === undefined) {
            return 'auto';
        }
        else {
            return `${container.getBoundingClientRect().right -
                rightBorderSize(container) -
                container.scrollLeft -
                elem.getBoundingClientRect().right -
                scrollLeft}px`;
        }
    });
}
export function calcLeftOffset(elem, container, scrollContainer) {
    return fastDom.measure(() => {
        var _a;
        const scrollLeft = (_a = scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollLeft) !== null && _a !== void 0 ? _a : 0;
        if (container.getBoundingClientRect().left === undefined) {
            return 'auto';
        }
        else {
            return `${elem.getBoundingClientRect().left +
                container.scrollLeft -
                (container.getBoundingClientRect().left + leftBorderSize(container)) +
                scrollLeft}px`;
        }
    });
}
export function freezePosition(element, container, scrollContainer) {
    if (document.dir === 'ltr') {
        element.style.right = 'auto';
        element.style.left = 'auto';
        calcLeftOffset(element, container, scrollContainer !== null && scrollContainer !== void 0 ? scrollContainer : undefined).then(left => (element.style.left = left), e => console.error(e));
    }
    else if (document.dir === 'rtl') {
        element.style.right = 'auto';
        element.style.left = 'auto';
        calcRightOffset(element, container, scrollContainer !== null && scrollContainer !== void 0 ? scrollContainer : undefined).then(right => (element.style.right = right), e => console.error(e));
    }
}
function leftBorderSize(elem) {
    if (!isNil(elem)) {
        return (pxToNum(getComputedStyle(elem).borderLeftWidth) +
            pxToNum(getComputedStyle(elem).marginLeft) +
            pxToNum(getComputedStyle(elem).paddingLeft));
    }
    else {
        return 0;
    }
}
function rightBorderSize(elem) {
    if (!isNil(elem)) {
        return (pxToNum(getComputedStyle(elem).borderRightWidth) +
            pxToNum(getComputedStyle(elem).marginRight) +
            pxToNum(getComputedStyle(elem).paddingRight));
    }
    else {
        return 0;
    }
}
export async function boundingClientRectAsync(elem) {
    return fastDom.measure(() => elem.getBoundingClientRect());
}
export function pxToNum(px) {
    return px.length > 2 ? Number(px.slice(0, px.length - 2)) : 0;
}
export const fastDom = new FastDomInternal();
export function documentDirection() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return getComputedStyle(document.getElementsByTagName('html').item(0)).direction;
}
export function appendStylesToTheStyleRoot(element, id, css) {
    var _a;
    const container = (_a = nearestShadowRoot(element)) !== null && _a !== void 0 ? _a : document.head;
    if (container.querySelector('#' + id) === null) {
        const style = document.createElement('style');
        style.id = id;
        style.innerHTML = css;
        container.appendChild(style);
    }
}
export function appendStylesToTheGlobalStyleRoot(id, css) {
    appendStylesToTheStyleRoot(document.body, id, css);
}
function nearestShadowRoot(element) {
    let current = element.parentNode;
    while (!isNil(current)) {
        if (current instanceof ShadowRoot) {
            return current;
        }
        current = current.parentNode;
    }
    return undefined;
}
export function supportsPopoverAPI() {
    return typeof HTMLElement.prototype.showPopover === 'function';
}
export function showPopover(element) {
    if (element && element.isConnected) {
        if (typeof element.showPopover === 'function') {
            element.showPopover();
        }
        else {
            element.style.display = 'block';
        }
    }
}
export function hidePopover(element) {
    if (element && element.isConnected) {
        if (typeof element.hidePopover === 'function') {
            element.hidePopover();
        }
        else {
            element.style.display = 'none';
        }
    }
}
